<script setup>
import { onMounted, onUnmounted, ref } from 'vue'

const props = defineProps({
  dropdownWidth: {
    type: String,
    default: '200px'
  }
})

// Variables
const isExpandOpen = ref(false)
const expandDropdown = ref(null)
const mouseX = ref(0)
const mouseY = ref(0)

onMounted(async () => {
  document.addEventListener('click', closeExpandOnOutsideClick)
})

onUnmounted(() => {
  document.removeEventListener('click', closeExpandOnOutsideClick)
})

function closeExpand() {
  isExpandOpen.value = false
}

function closeExpandOnOutsideClick(event) {
  if (expandDropdown.value && !expandDropdown.value.contains(event.target)) {
    closeExpand()
  }
}

function toggleExpand(event) {
  event.stopPropagation()
  isExpandOpen.value = !isExpandOpen.value
  if (isExpandOpen.value) {
    expandDropdown.value = document.querySelector(`.expand-dropdown`)
    mouseX.value = event.pageX
    mouseY.value = event.pageY
  }
}
</script>

<template>
  <div>
    <a href="#" @click.prevent="toggleExpand" class="expand-dropdown">
      <slot name="link"></slot>
    </a>

    <transition enter-active-class="transition ease-out duration-100"
                leave-active-class="transition ease-in duration-75">
      <div v-if="isExpandOpen"
           :style="{ top: `${mouseY}px`, left: `clamp(0px, calc(${mouseX}px - ${props.dropdownWidth}), calc(100vw - ${props.dropdownWidth}))`, 'max-width': props.dropdownWidth, width: '100vw' }"
           class="absolute z-[1000] mt-2 bg-white rounded-md shadow-lg">
        <ul class="z-10 w-full bg-white rounded-md shadow-lg right-0 mr-0 overflow-hidden" @click="closeExpand">
          <slot name="dropdown"></slot>
        </ul>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
</style>
